
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Videos from "../pages/videos/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/videos",
    element: <Videos />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;